import moment from "moment";
import * as types from "../types";

export const getProfiles = ({ role, page, perPage, filterProfileFullName }) => {
  const request = {
    type: types.GET_PROFILES,
    request: {
      url: "/profiles",
      method: "GET",
      params: page
        ? {
            "q[role]": role,
            "q[s]": "last_name asc",
            page,
            per_page: perPage
          }
        : {
            "q[role]": role,
            "q[s]": "last_name asc"
          }
    }
  };

  if (page && parseInt(page, 10) !== 1) {
    request.meta = {
      mutations: {
        [types.GET_PROFILES]: (prevData, newData) => {
          if (newData.meta.current_page <= prevData.meta.current_page) return newData;
          return { ...newData, data: prevData.data.concat(newData.data) };
        }
      }
    };
  }

  if (role === "teacher" && filterProfileFullName) {
    request.request.params = {
      ...request.request.params,
      "q[full_name_eq]": `${filterProfileFullName}`
    };
  }

  return request;
};

export const getExhibitorProfiles = ({ exhibitorId }) => ({
  type: types.GET_EXHIBITOR_PROFILES,
  request: {
    url: "/profiles",
    method: "GET",
    params: {
      "q[exhibitor_profiles_exhibitor_id_eq]": exhibitorId,
      "q[zoom_meeting_enabled]": true
    }
  }
});

export const getProfileMeetingSlots = ({ profileId, onlyAvailable = true }) => {
  const request = {
    type: types.GET_PROFILE_MEETING_SLOTS,
    request: {
      url: "/meeting_slots",
      method: "GET",
      params: {
        "q[profile_id_eq]": profileId
      }
    }
  };

  if (onlyAvailable) {
    request.request.params["q[start_at_gt]"] = moment().format();
    request.request.params["q[available_eq]"] = true;
  }

  return request;
};

export const updateProfile = ({ profile }) => ({
  type: types.UPDATE_PROFILE,
  request: {
    url: "/profiles/me",
    method: "PATCH",
    data: {
      profile
    }
  },
  meta: {
    mutations: {
      [types.GET_USER_ME]: ({ data }, newData) => {
        return { data: { ...data, profile: { ...newData.data } } };
      }
    }
  }
  // meta: {
  //   mutations: {
  //     [types.GET_USER_ME]: ({ data }) => {
  //       return { data: { ...data, profile: { ...data.profile, ...profile } } };
  //     }
  //   }
  // }
});

export const updateAvatarProfile = ({ avatar }) => {
  const formData = new FormData();
  formData.append("profile[avatar]", avatar);
  return {
    type: types.UPDATE_AVATAR_PROFILE,
    request: {
      url: "/profiles/avatar",
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_USER_ME]: ({ data }, newData) => {
          return { data: { ...data, profile: { ...newData.data } } };
        }
      }
    }
    // meta: {
    //   mutations: {
    //     [types.GET_USER_ME]: ({ data }) => {
    //       return { data: { ...data, profile: { ...data.profile, avatar } } };
    //     }
    //   }
    // }
  };
};

export const getProfilesNames = ({ role }) => ({
  type: types.GET_PROFILES_NAMES,
  request: {
    url: "/profiles/names",
    method: "GET",
    params: {
      "q[role]": role
    }
  }
});

export const getProfile = ({ profileId }) => ({
  type: types.GET_PROFILE,
  request: {
    url: `/profiles/${profileId}`,
    method: "GET",
    params: {}
  }
});

export const getProfileQAs = ({ profileId }) => ({
  type: types.GET_PROFILE_QAS,
  request: {
    url: `/profiles/${profileId}/question_answers`,
    method: "GET"
  }
});

export const createProfileQuestion = ({ profileId, question }) => ({
  type: types.CREATE_PROFILE_QA,
  request: {
    url: `/profiles/${profileId}/question_answers`,
    method: "POST",
    data: {
      questionAnswer: {
        question
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_PROFILE_QAS]: (prevData, newData) => {
        return { ...prevData, data: [...prevData.data, newData.data] };
      }
    }
  }
});
